module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "confirmation-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "ConfirmationModal__container"
  }, [(_vm.params.title) ? _c('div', {
    staticClass: "ConfirmationModal__title"
  }, [_vm._v("\n      " + _vm._s(_vm.params.title || '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.description) ? _c('div', {
    staticClass: "ConfirmationModal__description"
  }, [_vm._v("\n      " + _vm._s(_vm.params.description || '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.rememberOption) ? _c('div', {
    staticClass: "ConfirmationModal__remember-box"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.remember),
      expression: "params.remember"
    }],
    attrs: {
      "type": "checkbox",
      "id": "remember_confirmation"
    },
    domProps: {
      "checked": Array.isArray(_vm.params.remember) ? _vm._i(_vm.params.remember, null) > -1 : (_vm.params.remember)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.params.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.params, "remember", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.params, "remember", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.params, "remember", $$c)
        }
      }, _vm.remember]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-value",
    attrs: {
      "for": "remember_confirmation"
    }
  }, [_vm._v("\n          Don't show this anymore\n          "), _c('i', {
    staticClass: "icon-ic_tick"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.params.actions) ? _c('div', {
    staticClass: "form-actions centered"
  }, _vm._l((_vm.params.actions), function(action, i) {
    return _c('a', {
      key: i,
      class: action.class,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.click(i, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f1ba36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/confirmation.modal/confirmation.modal.vue
// module id = 441
// module chunks = 1